export default function NotFound({ children }: any) {
  return <div>Not found</div>
}
